import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const SECTIONS = [
  { to: '/subscriptions', end: true, labelKey: 'sections.overview' as const },
  { to: '/subscriptions/history', end: false, labelKey: 'sections.history' as const },
  { to: '/subscriptions/refer', end: false, labelKey: 'sections.refer' as const },
];

export const SubscriptionsSectionNav = () => {
  const { t } = useTranslation('billing');

  return (
    <nav
      className="flex shrink-0 gap-1 overflow-x-auto overflow-y-hidden border-b border-border pb-1 lg:w-44 lg:flex-col lg:overflow-visible lg:border-r lg:border-b-0 lg:pr-4 lg:pb-0"
      aria-label={t('title')}
    >
      {SECTIONS.map((section) => (
        <NavLink
          key={section.to}
          to={section.to}
          end={section.end}
          className={({ isActive }) =>
            cn(
              'shrink-0 rounded-md px-3 py-2 text-body-sm transition-colors',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-sunken hover:text-fg',
            )
          }
        >
          {t(section.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
